import React, { useState, useEffect } from "react";
import axios, { authIsValid } from "../axios";
import Loader from "./Loader";
import SendList from "./SendList";
import Glogo from "./Glogo";
import { useNavigate } from "react-router-dom";

function MyLists({ access_token }) {
  const newEmptyList = {
    listName: "",
    listItems: [],
  };
  const navigate = useNavigate();
  const [myLists, setMyLists] = useState([]);
  const [newListData, setNewListData] = useState(newEmptyList);
  const [type, setType] = useState("");
  const [colorCodes, setColorCodes] = useState([]);
  const [listItemCode, setListItemCode] = useState("");
  const [editOrNew, setEditOrNew] = useState("new");
  const [listToSend, setListToSend] = useState("");
  const [showSendList, setShowSendList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateList = async (e) => {
    e.preventDefault();

    if (editOrNew === "new") {
      try {
        const response = await axios.put(
          `/users/addToMyLists`,
          { newListData },
          { headers: { "x-access-token": access_token } }
        );
        if (response.data.message) {
          if (authIsValid(response.data.message) === false) {
            navigate("/mixer");
          } else {
            alert(response.data.message);
          }
        } else {
          setNewListData(newEmptyList);
          setMyLists((myLists) => [...myLists, response.data]);
        }
      } catch (err) {
        console.log(err.message);
      }
    } else if (editOrNew === "edit") {
      try {
        const response = await axios.put(
          `/users/updateMyLists`,
          { newListData },
          { headers: { "x-access-token": access_token } }
        );
        if (response.data.message) {
          if (authIsValid(response.data.message) === false) {
            navigate("/mixer");
          } else {
            alert(response.data.message);
          }
        } else {
          setEditOrNew("new");
          setNewListData(newEmptyList);

          let updatedList = myLists
            .filter((item) => item.id !== response.data.id)
            .concat(response.data);
          setMyLists(updatedList);
        }
      } catch (err) {
        console.log(err.message);
      }
    }
    setType("");
    setListItemCode("");
  };

  const handleListChange = (e) => {
    if (e.target.name === "listName") {
      setNewListData((prevState) => ({
        ...prevState,
        listName: e.target.value,
      }));
    } else if (listItemCode !== "") {
      const colorInfo = colorCodes.find((item) => item.code === listItemCode);
      setNewListData((prevState) => ({
        ...prevState,
        listItems: [...newListData.listItems, { ...colorInfo }],
      }));
      setListItemCode("");
    }
  };

  const handleRemoveListItem = (e) => {
    const updatedList = newListData.listItems.filter(
      (item) => item.id !== e.target.id
    );
    setNewListData((prevState) => ({
      ...prevState,
      listItems: [...updatedList],
    }));
  };

  const handleAccordion = (e) => {
    e.currentTarget.parentElement.nextSibling.classList.toggle("openAccordion");
    if (!e.currentTarget.classList.contains("open")) {
      e.currentTarget.classList.add("open");
    } else {
      e.currentTarget.classList.remove("open");
    }
  };

  const handleSendList = (e) => {
    e.stopPropagation();
    setListToSend(e.target.id);
    setShowSendList(true);
  };

  const handleEditList = (e) => {
    e.stopPropagation();
    let listItemColors = [];

    const listToEdit = myLists.find((list) => list.id === e.target.id);
    listToEdit.listItems.map((item) => {
      const element = {
        id: item.color._id,
        code: item.color.code,
        name: item.color.name,
        hex: item.color.hex,
      };
      listItemColors.push(element);
    });

    setEditOrNew("edit");
    setNewListData({
      listName: listToEdit.listName,
      listItems: [...listItemColors],
      listId: e.target.id,
    });
  };

  const handleCancelListEdit = () => {
    setEditOrNew("new");
    setNewListData(newEmptyList);
  };

  const handleDeleteList = async (e) => {
    try {
      const response = await axios.put(
        "/users/deleteList",
        { listId: e.target.id },
        { headers: { "x-access-token": access_token } }
      );
      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        setMyLists(myLists.filter((list) => list.id !== e.target.id));
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    const fetchTypeAndCode = async () => {
      try {
        const response = await axios.get(`/colors/${type}`);
        if (response.data.message) {
          if (authIsValid(response.data.message) === false) {
            navigate("/mixer");
          } else {
            alert(response.data.message);
          }
        } else {
          let fetchedColorCodes = [];
          response.data.map((color) =>
            fetchedColorCodes.push({
              id: color._id,
              code: color.code,
              name: color.name,
              hex: color.hex,
            })
          );
          setColorCodes([...fetchedColorCodes]);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    if (type !== "") {
      fetchTypeAndCode();
    }
  }, [type]);

  useEffect(() => {
    const fetchLists = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/users/myLists`, {
          headers: { "x-access-token": access_token },
        });
        if (response.data.message) {
          if (authIsValid(response.data.message) === false) {
            navigate("/mixer");
          } else {
            alert(response.data.message);
          }
        } else {
          setMyLists(response.data);
        }
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    };
    fetchLists();
  }, []);

  return (
    <div className="row col-12 justify-content-center no-print">
      {showSendList && (
        <SendList
          setShowSendList={(show) => setShowSendList(show)}
          access_token={access_token}
          listId={listToSend}
        />
      )}
      <div id="myListsContainer" className="col-10 no-print">
        <h5 className="futuraBold" style={{ marginTop: 10, marginBottom: 20 }}>
          My Lists
        </h5>
        <div className="row col-12">
          <div
            id="userLists"
            className="col-md-6 col-sm-12 col-xs-12"
            style={{ position: "relative" }}
          >
            {isLoading ? <Loader /> : ""}
            {myLists &&
              myLists.map((list) => {
                return (
                  <div key={list.id} className="listAccordion">
                    <div>
                      <p className="listName" onClick={handleAccordion}>
                        <b>{list.listName} </b>
                        <span>&#10095;</span>
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "flex-end",
                          rowGap: 15,
                        }}
                      >
                        <button
                          id={list.id}
                          className="btn btn-sm deleteListButton"
                          onClick={handleDeleteList}
                        >
                          Delete
                        </button>
                        <button
                          id={list.id}
                          className="btn btn-sm editListButton"
                          onClick={handleEditList}
                        >
                          Edit
                        </button>
                        <button
                          id={list.id}
                          className="btn btn-sm mailListButton"
                          onClick={handleSendList}
                        >
                          Send List
                        </button>
                      </div>
                    </div>
                    <ul>
                      {list.listItems.map((item, index) => {
                        return item === null || item === undefined ? (
                          <li key={index}>Formula no longer available</li>
                        ) : (
                          <li key={item._id}>
                            <Glogo
                              hasStroke={true}
                              size="sm"
                              color={item.color.hex}
                            />
                            {item.color && item.color.code}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
          </div>
          <div id="createList" className="col-md-6 col-sm-12 col-xs-12">
            <h5 style={{ textAlign: "center", marginBlock: "20px" }}>
              Create or Edit Lists
            </h5>
            <form
              className="row col-12 justify-content-center"
              onSubmit={handleCreateList}
            >
              <div className="form-group">
                <label
                  htmlFor="listName"
                  className="col-form-label col-md-2 col-sm-3 col-xs-4 text-center"
                >
                  List Name
                </label>
                <input
                  id="listName"
                  className="form-control"
                  name="listName"
                  type="text"
                  required
                  value={newListData.listName}
                  onChange={handleListChange}
                />
              </div>
              <div className="listItemsContainer col-md-12 col-sm-12 col-xs-12">
                {newListData.listItems.length > 0 &&
                  newListData.listItems.map((item) => {
                    return (
                      <div key={item.id} className="listItem">
                        <Glogo hasStroke={true} size="sm" color={item.hex} />
                        <span className="listItemText">
                          Code: {item.code},&emsp; Name: {item.name}
                        </span>
                        <button
                          id={item.id}
                          className="btn btn-sm"
                          onClick={handleRemoveListItem}
                          style={{ alignSelf: "flex-end" }}
                        >
                          Remove
                        </button>
                      </div>
                    );
                  })}
              </div>
              <div className="form-group col-md-5 col-sm-12 col-xs-12">
                <label
                  htmlFor="category"
                  className="col-form-label col-md-3 text-center"
                >
                  Type:
                </label>
                <select
                  id="category"
                  name="category"
                  className="form-select"
                  defaultValue=""
                  onChange={(e) => {
                    setType(e.target.value);
                    setListItemCode("");
                  }}
                >
                  <option hidden value="">
                    Choose...
                  </option>
                  <option value="UD">Uncoated Direct to Fabric</option>
                  <option value="CD">Coated Direct to Fabric</option>
                </select>
              </div>
              <div className="form-group col-md-5 col-sm-12 col-xs-12">
                <label
                  htmlFor="code"
                  className="col-form-label col-md-3 text-center"
                >
                  Code:
                </label>
                <select
                  id="code"
                  name="colorCode"
                  className="form-select"
                  defaultValue=""
                  onChange={(e) => setListItemCode(e.target.value)}
                >
                  <option hidden value="">
                    Choose...
                  </option>
                  {colorCodes.length > 0 &&
                    colorCodes.map((item) => (
                      <option key={item.code} value={item.code}>
                        {item.code}
                      </option>
                    ))}
                </select>
              </div>
              <div className="addToList col-md-2">
                <button
                  className="btn btn-md"
                  type="button"
                  onClick={handleListChange}
                >
                  Add
                </button>
              </div>
              <div className="createNewListButtons col-md-12 col-sm-12 col-xs-12 text-center">
                <button
                  className="btn"
                  type="button"
                  onClick={handleCancelListEdit}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-ryoForest"
                  type="submit"
                  style={{ marginLeft: "20px" }}
                >
                  {editOrNew === "new" ? "Create List" : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyLists;
